<template>
  <div id="defaultId1"  v-loading="RiskLoding" >
    <div class="margin-bottom10" v-show="AttributeDataShow">
      <div class="flex_center_between_box" >
        <gui_card
          id="ge6845"
          class="uc1096 comp_compet"
          label=""
          :isShowLabel="false"
          style="margin-right: 0px; flex: 1; height: auto"
        >
          <div>
            <h2 class="operations-head-content">
              <span class="operations-headspan" style="color: #009ea7;"
                >{{ $t("SearchTrade.CompanyCompetitiveness") }}
              </span>
            </h2>
            <div class="flex_center_between_box canvasBox">
              <div ref="Attributechart" class="attr_chart"></div>
              <div class="attr_table">
                <el-table
                  ref="treeTable"
                  style="max-height: 500px; overflow-y: auto; width: 100%;border: none;"
                  class="table_contentHeight_55 computer_right_cont_box"
                  :data="AttributeData"
                >
                  <!-- 空数据状态的插槽 -->
                  <template slot="empty">
                    {{ $t("SearchTrade.NoData") }}
                  </template>
                  <el-table-column
                    label=""
                    prop="attributeName"
                    width="190"
                    class-name="CompetitivenessTable"
                    align="left"
                    show-overflow-tooltip
                    :resizable="false"
                  />
                  <el-table-column
                    :label="$t('SearchTrade.GlobalMarketShare')"
                    prop="globalShare"
                    min-width="120"
                    align="left"
                    class-name="compet_table_cell_right  "
                    show-overflow-tooltip
                    :resizable="false"
                  />
                  <el-table-column
                    :label="$t('SearchTrade.RegionalMarketShare')"
                    prop="regionalShare"
                    min-width="120"
                    align="left"
                    show-overflow-tooltip
                    class-name="compet_table_cell_right  "
                    :resizable="false"
                  >
                  </el-table-column>
                  <el-table-column
                    :label="$t('SearchTrade.BusinessGrowthGlobalMarket')"
                    prop="businessGrowthWithGlobal"
                    min-width="120"
                    align="left"
                    class-name="compet_table_cell_right  "
                    show-overflow-tooltip
                    :resizable="false"
                  >
                  </el-table-column>
                  <el-table-column
                    :label="$t('SearchTrade.BusinessGrowthRegionalMarket')"
                    prop="businessGrowthWithRegional"
                    min-width="120"
                    align="left"
                    class-name="compet_table_cell_right  "
                    show-overflow-tooltip
                    :resizable="false"
                  >
                  </el-table-column>

                  <el-table-column
                    :label="$t('SearchTrade.CreditRating')"
                    prop="creditRating"
                    align="left"
                    class-name="compet_table_cell_right "
                    show-overflow-tooltip
                    :resizable="false"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </gui_card>
      </div>
    </div>
    <div class="pb20">
      <div class="flex_center_between_box" v-if="profitablitylist?.length > 0">
        <gui_card
          id="ge6845"
          class="uc1096 margin-right10 cred_table_chart"
          label=""
          :isShowLabel="false"
          style="flex: 1; height: auto"
        >
          <div>
            <h2 class="operations-head-content">
              <span class="operations-headspan"  style="color: #009ea7;"
                >{{ $t("SearchTrade.CreditAssessment") }}
              </span>
            </h2>
            <tableVue
              class=""
              :profitablitylist="profitablitylist"
              :yearslist="yearslist1"
              :untia="untia"
              :createDialog="createDialog"
              @createDialogcheck="createDialogcheck"
            ></tableVue>
          </div>
        </gui_card>
        <gui_card
          id="ge6845"
          class="uc1096 cred_chart"
          label=""
          :isShowLabel="false"
          style="padding: 0px !important"
        >
          <div class="">
            <div class="table">
              <div class="table_box">
                <span class="aaa">{{ $t("SearchTrade.HighRisk") }}</span>
                <span class="bbb">{{ $t("SearchTrade.Medium") }}</span>
                <span class="ccc">{{ $t("SearchTrade.Moderate") }}</span>
                <span class="ddd">{{ $t("SearchTrade.Average") }}</span>
                <span class="fff">{{ $t("SearchTrade.LowerThanAvg") }}</span>
                <span class="ggg">{{ $t("SearchTrade.LowRisk") }}</span>
                <span class="hhh">{{ $t("SearchTrade.CreditOpinion") }}</span>
                <div class="echarts" ref="riskRef"></div>
                <ul class="echarts-content">
                  <li
                    class="echarts-item"
                    v-for="(item, index) in cardlist"
                    :key="index"
                  >
                    <span class="echarts-item-left font18">{{
                      item.title
                    }}</span
                    ><span class="font18">{{ item.text }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </gui_card>
      </div>
      <gui_card
        v-show="Related"
        id="ge6845"
        class="uc1096 mt10"
        label=""
        :isShowLabel="false"
      >
        <div>
          <h2 class="operations-head-content">
            <span class="operations-headspan">{{ $t("SearchTrade.RelatedCreditAssessment") }}</span>
            <svg
              @click="Related = false"
              t="1718863593010"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="4791"
              width="1.85rem"
              height="1.85rem"
            >
              <path
                d="M547.4 512l278.2-278.2c9.8-9.8 9.8-25.6 0-35.4-9.8-9.8-25.6-9.8-35.4 0L512 476.6 233.8 198.4c-9.8-9.8-25.6-9.8-35.4 0-9.8 9.8-9.8 25.6 0 35.4L476.6 512 198.4 790.2c-9.8 9.8-9.8 25.6 0 35.4 4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3L512 547.4l278.2 278.2c4.9 4.9 11.3 7.3 17.7 7.3s12.8-2.4 17.7-7.3c9.8-9.8 9.8-25.6 0-35.4L547.4 512z"
                fill="#333333"
                p-id="4792"
              ></path>
            </svg>
          </h2>
          <!-- 关联公司 -->
        </div>
      </gui_card>
    </div>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
  <!--srcviewscompanydetailsBackgroundSnapshotvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart
import {
  getrelatedCompanylist,
  getCreditAssessment,
  getAttrbuteComparisonTrade,
} from "@/api/companyApi";
import rectcard from "../../../../components/rectCard/index.vue";
import content_text from "../../../../components/text_content/index.vue";
import gui_card from "../../../../components/gui_card/gui_card.vue";
import tableVue from "../CreditOpinion/table.vue";
import ReLogin from "../../../../components/ReLogin.vue";

//importEnd

export default {
  name: "",

  props: {},

  components: {
    gui_card,
    rectcard,
    content_text,
    tableVue,
    ReLogin,
  },
  computed: {
    cardlist() {
      return [
        {
          title: this.$t("SearchTrade.LocalCreditScore") + ":",
          text: "-",
        },

        {
          title: this.$t("SearchTrade.SolvencyIndex") + ":",
          text: "-",
        },
        {
          title: this.$t("SearchTrade.ProbabilityofDefault") + ":",
          text: "-",
        },
        {
          title: this.$t("SearchTrade.CreditLine") + ":",
          text: "-",
        },
         {
          title: this.$t("SearchTrade.RiskIndicator") + ":",
          text: "-",
        },
      ];
    },
  },
  created() {},
  mounted() {
    this.getlist();
    this.riskEchart();
    // this.Attributechart()
    this.$emit("UpdatamarkTotalList", true);

    this.getAttrbuteComparisonTradeList();

    window.addEventListener("resize", this.resizeFn);
  },
  data() {
    return {
      reLoginVis: false,
      RiskLoding: false,
      page: {
        pageNo: 1,
        pageSize: 20,
        total: 0,
      },
      Related: false,
      untia: "",
      yearslist1: [],
      createDialog: false,
      parentTablelist: [],
      loginStatus1: [],
      id3a: [],
      profitablitylist: [
        {
          lists: [
            {
              change: "",
              value: "",
            },
            {
              change: "",
              value: "",
            },
            {
              change: "",
              value: "",
            },
          ],
          name: this.$t("SearchTrade.ReturnonEquity") +":",
        },

        {
          lists: [
            {
              change: "",
              value: "",
            },
            {
              change: "",
              value: "",
            },
            {
              change: "",
              value: "",
            },
          ],
          name: this.$t("SearchTrade.ProfitMargin") +":",
        },
      ],
      profitablitylist1: [
        {
          lists: [
            {
              change: "",
              value: "",
            },
            {
              change: "",
              value: "",
            },
            {
              change: "",
              value: "",
            },
          ],
          name: this.$t("SearchTrade.ReturnonEquity") +":",
        },

        {
          lists: [
            {
              change: "",
              value: "",
            },
            {
              change: "",
              value: "",
            },
            {
              change: "",
              value: "",
            },
          ],
          name: this.$t("SearchTrade.ProfitMargin") +":",
        },
      ],
      AttributeData: [],
      AttributeDataShow:true,
      tradeDetailList: [],
      maxValue: {},
      minValue: {},
      companyList: [],
      noMore: false, // 控制滚动禁用
      routeLoad: false, // 控制滚动禁用
      icon: "",
      showBackToTop: false,
      newDialog: false,
      creditOpinion: "",
      creditScore: "",

      // srcviewscompanydetailsBackgroundSnapshotvueDataEnd
    };
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeFn);
  },
  methods: {
    getAttrbuteComparisonTradeList() {
      this.RiskLoding = true;
      getAttrbuteComparisonTrade({ aaaid: this.$route.query.id3a }).then(
        (res) => {
          if (res.code == 200) {
            console.log("getAttrbuteComparisonTrade");
            console.log(res.data);
            this.RiskLoding = false;
            if(res.data.attrvalueComparisonTable){
              this.AttributeDataShow=res.data.attrvalueComparisonTable.length>0;
            }
            else{
              this.AttributeDataShow=false;
            } 
            this.AttributeData = res.data.attrvalueComparisonTable;
            this.maxValue = res.data.max;
            this.maxValue.creditRating = 19;
            this.minValue = res.data.min;
            this.minValue.creditRating = 0;
            this.Attributechart();
          } else {
            this.RiskLoding = false;
          }
        },
      );
    },
    initSuperTable(arr){
       if( arr<1){
         arr="<1%";
        }
        else{ 
          arr= parseFloat(arr).toFixed(2)+"%"; 
        }
      return arr;
    },
  
    resizeFn() {
      this.Attributechart();
    },
    setNews(row, detail) {
      let newscountry = JSON.parse(localStorage.getItem("countryList"))[0]
        .countryList;
      let SACode1 = "";
      newscountry.map((item) => {
        if (item.countryCode == this.$route.query.companyCountry) {
          SACode1 = item.dowjonesCountrycode;
        }
      });
      let routeData = "";
      if (detail == "prife") {
        routeData = this.$router.resolve({
          path:
            "/index/company/details/" +
            this.$route.query.id3a +
            "/background/snapshot?id3a=" +
            this.$route.query.id3a +
            "&companyCountry=" +
            this.$route.query.companyCountry +
            "&SACode1=" +
            SACode1 +
            "&companyName=" +
            this.$route.query.companyName +
            "&keword=" +
            this.$route.query.keword,
        });
      } else {
        routeData = this.$router.resolve({
          path:
            "/index/company/details/" +
            this.$route.query.id3a +
            "/background/snapshot?id3a=" +
            this.$route.query.id3a +
            "&companyCountry=" +
            this.$route.query.companyCountry +
            "&SACode1=" +
            SACode1 +
            "&idpower=442" +
            "&companyName=" +
            this.$route.query.companyName +
            "&keword=" +
            this.$route.query.keword,
        });
      }

      window.open(routeData.href, "_blank");
    },
    scrollToTop() {
      this.Related = true;
    },
    createDialogcheck(value) {
      this.createDialog = value;
    },
    getlist() {
      const params = {
        id3a: this.$route.query.id3a,
      };
      getCreditAssessment(params)
        .then((res) => {
          this.loading = false;
          let data = res;
          if (data.code) {
            this.loading = false;
            let { ca, creditBO, years, unit } = data.data;
            this.untia = unit;
            this.profitablitylist = ca;
            this.yearslist1 = years;
            this.cardlist.map((item, index) => {
              if (item.title == this.$t("SearchTrade.LocalCreditScore") + ":") {
                item.text = creditBO.creditScore;
              }
              if (
                item.title ==
                this.$t("SearchTrade.ProbabilityofDefault") + ":"
              ) {
                item.text = creditBO.pd;
              }
              if (item.title == this.$t("SearchTrade.SolvencyIndex") + ":") {
                item.text = creditBO.si;
              }
              if (item.title == this.$t("SearchTrade.RiskIndicator") + ":") {
                item.text = creditBO.riskIndicator;
              }  
              if (item.title == this.$t("SearchTrade.CreditLine") + ":") {
                item.text = creditBO.creditLine;
              }
            });
            this.creditOpinion = creditBO?.creditOpinion;
            this.creditScore = Number(creditBO?.creditScore) / 100;
          } else {
            this.loading = false;
            this.creditOpinion = "unrated";
            this.creditScore = 0;
          }
          this.$nextTick(() => {
            this.riskEchart();
          });
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    infiniteScroll() {
      this.routeLoad = false;
    },

    // 添加对数转换辅助方法
    // 添加对数转换辅助方法，带格式化功能
    logTransform(value) {
      // 处理零值或负值的情况
      if (value <= 0) {
        return 0;
      }
      // 对数转换，这里使用自然对数
      const logValue = Math.log(value + 1);
      // 限制小数位数，避免科学计数法
      return parseFloat(logValue.toFixed(6));
    },

    // 反向对数转换（用于显示原始值）
    // 添加对数转换辅助方法，带格式化功能
    logTransform(value) {
      // 处理零值或负值的情况
      if (value <= 0) {
        return 0;
      }
      // 对数转换，这里使用自然对数
      const logValue = Math.log(value + 1);
      // 限制小数位数，避免科学计数法
      return parseFloat(logValue.toFixed(6));
    },

    // 反向对数转换（用于显示原始值）
    inverseLogTransform(logValue) {
      return Math.exp(logValue) - 1;
    },

    // 数值格式化方法，避免科学计数法
    formatNumberForDisplay(value) {
      if (typeof value !== "number" || isNaN(value)) {
        return value || "-";
      }

      // 如果是整数或小数位较少的数，直接返回
      if (Number.isInteger(value) || Math.abs(value) < 1e-6) {
        return value.toFixed(6).replace(/\.?0+$/, "");
      }

      // 避免科学记数法的格式化
      const str = value.toFixed(6);
      // 移除尾部多余的零
      return str.replace(/\.?0+$/, "");
    },

    Attributechart() {
      let that = this;
      let leidaDate = [];

      this.AttributeData.forEach((item) => {
        const creditRatingNum = that.creditRatingNum(item.creditRating);

        // 对需要的数值进行对数转换，同时保留原始数据用于显示
        const transformedValues = [
          that.logTransform(item.globalShare),
          that.logTransform(item.regionalShare),
          that.logTransform(item.businessGrowthWithRegional),
          that.logTransform(item.businessGrowthWithGlobal),
          creditRatingNum || 0, // 信用评级已经是数字，不需要对数转换
        ];

        leidaDate.push({
          value: transformedValues, // 使用对数转换后的值进行绘图
          name: item.attributeName,
          originalValues: [
            // 保存原始值用于tooltip显示
            item.globalShare,
            item.regionalShare,
            item.businessGrowthWithRegional,
            item.businessGrowthWithGlobal,
            creditRatingNum ? `3A${creditRatingNum}` : "-",
          ],
          valueTrue: [
            that.formatNumber(item.globalShare),
            that.formatNumber(item.regionalShare),
            that.formatNumber(item.businessGrowthWithRegional),
            that.formatNumber(item.businessGrowthWithGlobal),
            creditRatingNum ? `3A${creditRatingNum}` : "-",
          ],
        });
      });

      console.log("leidaDate", leidaDate);

      this.echartsBox = this.$echarts.init(this.$refs.Attributechart);
      const option = {
        color: ["#009EA7", "#F867B5", "#FF7600"],
        grid: {
          left: "4%",
          right: "4%",
          top: "6%",
          bottom: "0%",
          containLabel: true,
        },
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            // 使用原始值而不是对数转换后的值
            const originalValues = params.data.originalValues;
            return `
          ${that.$t("SearchTrade.GlobalMarketShare")}: ${that.formatNumber(
              originalValues[0],
            )}<br/>
          ${that.$t("SearchTrade.RegionalMarketShare")}: ${that.formatNumber(
              originalValues[1],
            )}<br/>
          ${that.$t(
            "SearchTrade.BusinessGrowthRegionalMarket",
          )}: ${that.formatNumber(originalValues[2])}<br/>
          ${that.$t(
            "SearchTrade.BusinessGrowthGlobalMarket",
          )}: ${that.formatNumber(originalValues[3])}<br/>
          ${that.$t("SearchTrade.CreditRating")}: ${originalValues[4]}
        `;
          },
        },
        legend: {
          data: this.AttributeData.map((item) => item.attributeName),
          right: "0%",
          top: "0%",
          orient: "vertical",
          textStyle: {
            color: "#1a2332",
            fontSize: 12,
            fontFamily: "Arial Arial",
          },
        },
        radar: {
          axisName: {
            color: "#1A2332",
            fontSize: 16,
            fontWeight: "normal",
            fontFamily: "Arial, Arial",
          },
          // 对轴的最大最小值也应用对数转换并格式化
          indicator: [
            {
              name: this.$t("SearchTrade.GlobalMarketShare"),
              max: that.logTransform(that.maxValue.globalShare),
              min: that.logTransform(that.minValue.globalShare),
              fontSize: 12,
              // 自定义轴标签格式，显示对应的实际值
              formatter: function (val) {
                // 将对数值转换回近似的实际值以显示
                const approxOriginal = that.inverseLogTransform(val);
                return that.formatNumber(approxOriginal);
              },
            },
            {
              name: this.$t("SearchTrade.RegionalMarketShare"),
              max: that.logTransform(that.maxValue.regionalShare),
              min: that.logTransform(that.minValue.regionalShare),
              fontSize: 12,
              formatter: function (val) {
                const approxOriginal = that.inverseLogTransform(val);
                return that.formatNumber(approxOriginal);
              },
            },
            {
              name: this.$t("SearchTrade.BusinessGrowthGlobalMarket"),
              max: that.logTransform(that.maxValue.businessGrowthWithGlobal),
              min: that.logTransform(that.minValue.businessGrowthWithGlobal),
              fontSize: 12,
              formatter: function (val) {
                const approxOriginal = that.inverseLogTransform(val);
                return that.formatNumber(approxOriginal);
              },
            },
            {
              name: this.$t("SearchTrade.BusinessGrowthRegionalMarket"),
              max: that.logTransform(that.maxValue.businessGrowthWithRegional),
              min: that.logTransform(that.minValue.businessGrowthWithRegional),
              fontSize: 12,
              formatter: function (val) {
                const approxOriginal = that.inverseLogTransform(val);
                return that.formatNumber(approxOriginal);
              },
            },
            {
              name: this.$t("SearchTrade.CreditRating"),
              max: that.maxValue.creditRating,
              min: that.minValue.creditRating,
              fontSize: 12,
            },
          ],
        },
        series: [
          {
            name: "Budget vs spending",
            type: "radar",
            axisLabel: {
              color: "#1A2332",
              fontSize: 14,
              fontWeight: "normal",
              fontFamily: "Arial, Arial",
            },
            data: leidaDate,
          },
        ],
      };
      this.echartsBox.setOption(option);
      this.echartsBox.resize();

       this.AttributeData.forEach((item) => {
        
       item.globalShare=   this.initSuperTable(item.globalShare);
         item.regionalShare=this.initSuperTable(item.regionalShare);
        item.businessGrowthWithRegional=  this.initSuperTable(item.businessGrowthWithRegional);
        item.businessGrowthWithGlobal=  this.initSuperTable(item.businessGrowthWithGlobal);
        
       });

    },
    // 数字千分为
    creditRatingNum(rating) {
      const ratingMap = {
        AAA: 1,
        "AA+": 2,
        AA: 3,
        "AA-": 4,
        "A+": 5,
        A: 6,
        "A-": 7,
        "BBB+": 8,
        BBB: 9,
        "BBB-": 10,
        "BB+": 11,
        BB: 12,
        "BB-": 13,
        "B+": 14,
        B: 15,
        "B-": 16,
        CCC: 17,
        CC: 18,
        C: 19,
      };

      return ratingMap[rating] || null; // 如果评级不在映射表中，返回 null
    },
    // 数字千分为
    formatNumber(value) {
      const number = parseFloat(value);
      if (isNaN(number)) {
        return "";
      }

      // 根据数字大小选择单位
      if (number >= 1e9) {
        return this.toThousandSeparator((number / 1e9).toFixed(2)) + "b";
      } else if (number >= 1e6) {
        return this.toThousandSeparator((number / 1e6).toFixed(2)) + "m";
      } else if (number >= 1e3) {
        return this.toThousandSeparator((number / 1e3).toFixed(2)) + "k";
      } else {
        return this.toThousandSeparator(number.toString());
      }
    },
    toThousandSeparator(numStr) {
      // 使用正则表达式为数字添加千分位
      const parts = numStr.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    },
    // 获取数据
    getparamslist(params, index) {
      getCreditAssessment(params).then((res) => {
        this.parentTablelist[index].loading2 = false;
        let data = res;

        let { ca, creditBO, years, unit } = data.data;
        this.parentTablelist[index].yearslist = years;
        this.id3a = years;
        this.parentTablelist[index].profitablitylist1 = ca;
        this.untia = unit;
        let that = this;
        that.loginStatus1[index] = true;
        this.parentTablelist[index].relatedcardlist.map((item, index) => {
          if (item.title == this.$t("SearchTrade.LocalCreditScore") + ":") {
            item.text = creditBO.creditScore;
          }
          if (item.title == this.$t("SearchTrade.ProbabilityofDefault") + ":") {
            item.text = creditBO.pd;
          }
          if (item.title == this.$t("SearchTrade.SolvencyIndex") + ":") {
            item.text = creditBO.si;
          }
          if (item.title == this.$t("SearchTrade.RiskIndicator") + ":") {
            item.text = creditBO.riskIndicator;
          }
        });

        this.creditOpinion = creditBO?.creditOpinion;
        this.creditScore = Number(creditBO?.creditScore) / 100;
        const option = {
          grid: {
            left: "0",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          //
          series: [
            {
              type: "gauge",
              startAngle: 180,
              endAngle: 0,

              center: ["50%", "75%"],
              radius: "146%",
              clockwise: true,
              show: true,
              min: 0,
              max: 1,
              splitNumber: 5,

              axisLine: {
                roundCap: true,
                lineStyle: {
                  width: 20,

                  color: [
                    [
                      0.25,
                      {
                        type: "linear",

                        x: 0,

                        y: 0,

                        x2: 0,

                        y2: 1,

                        colorStops: [
                          {
                            offset: 1,
                            color: "#F56B6BFF",
                          },
                        ],

                        global: false,
                      },
                    ],

                    [
                      0.5,
                      {
                        type: "linear",

                        x: 0,

                        y: 0,

                        x2: 0,

                        y2: 1,

                        colorStops: [
                          {
                            offset: 0,
                            color: "#FFDC17FF",
                          },
                          {
                            offset: 1,
                            color: "#FA6666FF",
                          },
                        ],

                        global: false,
                      },
                    ],

                    [
                      1,
                      {
                        type: "linear",

                        x: 0,

                        y: 0,

                        x2: 0,

                        y2: 1,

                        colorStops: [
                          {
                            offset: 0,
                            color: "#FFDC17FF",
                          },
                          {
                            offset: 1,
                            color: "#55B419FF",
                          },
                        ],

                        global: false,
                      },
                    ],
                  ],
                },
              },

              pointer: {
                icon: "circle",

                length: "20%",
                width: 22,
                offsetCenter: [0, "-85%"],
                itemStyle: {
                  color: "auto",
                },
              },
              axisTick: {
                length: 5,
                distance: -28,
                lineStyle: {
                  color: "auto",
                  width: 2,
                },
              },
              // 刻度线
              splitLine: {
                show: false,
                length: 10,
                lineStyle: {
                  color: "auto",
                  width: 8,
                },
              },
              axisLabel: {
                show: false,
                rotate: "tangential",
                fontWeight: "normal",
                fontSize: 0,
                distance: -62,
                width: 70,
                height: 40,
                fontFamily: "Arial Bold",
                overflow: "truncate",
                color: [
                  [
                    0.25,
                    {
                      type: "linear",

                      x: 0,

                      y: 10,

                      x2: 30,

                      y2: 11,

                      colorStops: [
                        {
                          offset: 1,
                          color: "#F56B6BFF",
                        },
                      ],

                      global: false,
                    },
                  ],

                  [
                    0.5,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 0,
                          color: "#FFDC17FF",
                        },
                        {
                          offset: 1,
                          color: "#FA6666FF",
                        },
                      ],

                      global: false,
                    },
                  ],

                  [
                    1,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 0,
                          color: "#FFDC17FF",
                        },
                        {
                          offset: 1,
                          color: "#55B419FF",
                        },
                      ],

                      global: false,
                    },
                  ],
                ],

                formatter: function (value) {
                  if (value === 1) {
                    return "Low Risk";
                  } else if (value === 0.8) {
                    return "Lower Than Avg.";
                  } else if (value === 0.6) {
                    return "Average";
                  } else if (value === 0.4) {
                    return "Moderate";
                  } else if (value === 0.2) {
                    return "Medium";
                  } else if (value === 0.0) {
                    return "High Risk";
                  }
                  return "";
                },
              },

              title: {
                offsetCenter: [0, "20%"],
                fontSize: 15,
                color: "#ccc",
              },
              // 仪表盘数字
              detail: {
                lineHeight: 126,
                fontSize: 35,
                offsetCenter: [1, "-22"],
                valueAnimation: true,

                borderColor: "#55B419FF",

                width: 200,
                formatter: function (value) {
                  var a = "d";
                  if (Math.round(value * 100)) {
                    a = "A";
                  }
                  return that.creditOpinion;
                },
                color: "#55B419FF",
              },
              data: [
                {
                  value: that.creditScore,
                },
              ],
            },
            {
              type: "gauge",
              startAngle: 180,
              endAngle: 0,
              center: ["50%", "75%"],
              radius: "96%",
              min: 0,
              max: 1,

              axisTick: {
                show: false,
              },
              splitLine: {
                show: false,
              },
              axisLabel: {
                show: false,
              },
              axisLine: {
                lineStyle: {
                  width: 1,
                  color: [
                    [
                      0.5,
                      {
                        type: "linear",

                        x: 0,

                        y: 0,

                        x2: 0,

                        y2: 1,

                        colorStops: [
                          {
                            offset: 0,
                            color: "#FFDC17FF",
                          },
                          {
                            offset: 1,
                            color: "#FA6666FF",
                          },
                        ],

                        global: false,
                      },
                    ],

                    [
                      1,
                      {
                        type: "linear",

                        x: 0,

                        y: 0,

                        x2: 0,

                        y2: 1,

                        colorStops: [
                          {
                            offset: 0,
                            color: "#FFDC17FF",
                          },
                          {
                            offset: 1,
                            color: "#55B419FF",
                          },
                        ],

                        global: false,
                      },
                    ],
                  ],
                },
              },
              pointer: {
                icon: "triangle",
                length: "12%",
                width: 20,
                offsetCenter: [0, "-105%"],
                itemStyle: {
                  color: "#55B419FF",
                },
              },

              data: [
                {
                  value: that.creditScore,
                  detail: {
                    show: false,
                  },
                },
              ],
            },
          ],
        };

        const chartDom = this.$refs.chartRef[index];
        const chart =
          this.$echarts.getInstanceByDom(chartDom) ||
          this.$echarts.init(chartDom);
        chart.setOption(option);
        this.parentTablelist[index].chartInstance = chart;
      });
    },

    riskEchart() {
      const that = this;
      const option = {
        grid: {
          left: "0",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        //
        series: [
          {
            type: "gauge",
            startAngle: 180,
            endAngle: 0,

            center: ["50%", "75%"],
            radius: "146%",
            clockwise: true,
            show: true,
            min: 0,
            max: 1,
            splitNumber: 5,

            axisLine: {
              roundCap: true,
              lineStyle: {
                width: 20,

                color: [
                  [
                    0.25,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 1,
                          color: "#F56B6BFF",
                        },
                      ],

                      global: false,
                    },
                  ],

                  [
                    0.5,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 0,
                          color: "#FFDC17FF",
                        },
                        {
                          offset: 1,
                          color: "#FA6666FF",
                        },
                      ],

                      global: false,
                    },
                  ],

                  [
                    1,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 0,
                          color: "#FFDC17FF",
                        },
                        {
                          offset: 1,
                          color: "#55B419FF",
                        },
                      ],

                      global: false,
                    },
                  ],
                ],
              },
            },

            pointer: {
              icon: "circle",

              length: "20%",
              width: 22,
              offsetCenter: [0, "-85%"],
              itemStyle: {
                color: "auto",
              },
            },
            axisTick: {
              length: 5,
              distance: -28,
              lineStyle: {
                color: "auto",
                width: 2,
              },
            },
            // 刻度线
            splitLine: {
              show: false,
              length: 10,
              lineStyle: {
                color: "auto",
                width: 8,
              },
            },
            axisLabel: {
              show: false,
              rotate: "tangential",
              fontWeight: "normal",
              fontSize: 0,
              distance: -62,
              width: 70,
              height: 40,

              fontFamily: "Arial Bold",
              overflow: "truncate",
              color: [
                [
                  0.25,
                  {
                    type: "linear",

                    x: 0,

                    y: 10,

                    x2: 30,

                    y2: 11,

                    colorStops: [
                      {
                        offset: 1,
                        color: "#F56B6BFF",
                      },
                    ],

                    global: false,
                  },
                ],

                [
                  0.5,
                  {
                    type: "linear",

                    x: 0,

                    y: 0,

                    x2: 0,

                    y2: 1,

                    colorStops: [
                      {
                        offset: 0,
                        color: "#FFDC17FF",
                      },
                      {
                        offset: 1,
                        color: "#FA6666FF",
                      },
                    ],

                    global: false,
                  },
                ],

                [
                  1,
                  {
                    type: "linear",

                    x: 0,

                    y: 0,

                    x2: 0,

                    y2: 1,

                    colorStops: [
                      {
                        offset: 0,
                        color: "#FFDC17FF",
                      },
                      {
                        offset: 1,
                        color: "#55B419FF",
                      },
                    ],

                    global: false,
                  },
                ],
              ],

              formatter: function (value) {
                if (value === 1) {
                  return "Low Risk";
                } else if (value === 0.8) {
                  return "Lower Than Avg.";
                } else if (value === 0.6) {
                  return "Average";
                } else if (value === 0.4) {
                  return "Moderate";
                } else if (value === 0.2) {
                  return "Medium";
                } else if (value === 0.0) {
                  return "High Risk";
                }
                return "";
              },
            },

            title: {
              offsetCenter: [0, "20%"],
              fontSize: 15,
              color: "#ccc",
            },
            // 仪表盘数字
            detail: {
              lineHeight: 126,
              fontSize: 35,
              offsetCenter: [1, "-22"],
              valueAnimation: true,

              borderColor: "#55B419FF",

              width: 200,
              formatter: function (value) {
                var a = "d";
                if (Math.round(value * 100)) {
                  a = "A";
                }
                return that.creditOpinion;
              },
              color: "#55B419FF",
            },
            data: [
              {
                value: that.creditScore,
              },
            ],
          },
          {
            type: "gauge",
            startAngle: 180,
            endAngle: 0,
            center: ["50%", "75%"],
            radius: "96%",
            min: 0,
            max: 1,

            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                width: 1,
                color: [
                  [
                    0.5,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 0,
                          color: "#FFDC17FF",
                        },
                        {
                          offset: 1,
                          color: "#FA6666FF",
                        },
                      ],

                      global: false,
                    },
                  ],

                  [
                    1,
                    {
                      type: "linear",

                      x: 0,

                      y: 0,

                      x2: 0,

                      y2: 1,

                      colorStops: [
                        {
                          offset: 0,
                          color: "#FFDC17FF",
                        },
                        {
                          offset: 1,
                          color: "#55B419FF",
                        },
                      ],

                      global: false,
                    },
                  ],
                ],
              },
            },
            pointer: {
              icon: "triangle",
              length: "12%",
              width: 20,
              offsetCenter: [0, "-105%"],
              itemStyle: {
                color: "#55B419FF",
              },
            },

            data: [
              {
                value: that.creditScore,
                detail: {
                  show: false,
                },
              },
            ],
          },
        ],
      };
      this.riskChart = this.$echarts.init(this.$refs.riskRef);
      this.riskChart.setOption(option);
    },
    // insertMethod
    // srcviewscompanydetailsBackgroundSnapshotvueMethodStart
    // default
    default() {},
    // srcviewscompanydetailsBackgroundSnapshotvueMethodEnd
  },
};
</script>

<style scoped>
.uPdtqFl {
  padding-right: 2.857142857142857rem;
  padding-top: 2.142857142857143rem;
  padding-left: 2.857142857142857rem;
  padding-bottom: 2.142857142857143rem;
  box-shadow: 0rem 0.14285714285714285rem 1rem 0rem rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.importDetail-head {
  display: flex;
}

.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}
.canvasBox {
  gap: 20px;
}
.attr_chart {
  height: 450px;
  flex: 1;
}
.contclass {
  font-size: 1.285714285714286rem;
  color: #238acc;
  font-weight: normal;
  font-style: normal;
  cursor: pointer;
}

.ViewMore {
  line-height: 1.8571428571428572rem;
  text-align: left;
  font-style: normal;
  text-decoration-line: underline;
  margin-left: 2.142857142857143rem;
}

.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title-left {
  display: flex;
  font-size: 1.1428571428571428rem;
  font-family: "Arial Bold";
  font-weight: normal;
  color: #022955;
  padding-left: 1.4285714285714286rem;
  display: flex;
  align-items: center;
  padding-bottom: 0.9285714285714286rem;
  padding-top: 0.9285714285714286rem;
}
.title-left .relate-left {
  font-family: "Arial Bold";
}

.footer {
  padding-left: 0rem;
  overflow: hidden;
}

.ecahrts-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 0.07142857142857142rem solid #cccccc;
}

.td {
  margin: 1.0714285714285714rem 0 0 1.7857142857142858rem;
}

.relate-left {
  height: 4rem;
  font-size: 1.285714285714286rem;
  color: #1a2332;
  line-height: 4rem;
  text-align: left;
  font-family: "Arial Bold";
}

.relate-Financial {
  font-size: 1.285714285714286rem;
  color: #1a2332;
}
.ecahrts-header-one .relate-Financial,
.ecahrts-header-one .relate-left {
  font-size: 1.4285714285714286rem;
}

.tablewieth {
  width: 70%;
}
.aaa {
  font-size: 14px;
  color: #fa6666;
  position: absolute;
  left: 50px;
  top: 190px;
}

.bbb {
  font-size: 14px;
  color: #fa755c;
  position: absolute;
  left: 45px;
  top: 90px;
}

.ccc {
  font-size: 14px;
  color: #fc9249;
  position: absolute;
  left: 120px;
  top: 5px;
}

.ddd {
  font-size: 14px;
  color: #ffd81a;
  position: absolute;
  left: 340px;
  top: 5px;
}

.fff {
  font-size: 14px;
  color: #aec918;
  position: absolute;
  width: 64px !important;
  height: 36px;
  left: 430px;
  top: 90px;
}

.ggg {
  font-size: 14px;
  color: #63b819;
  position: absolute;
  left: 410px;
  top: 190px;
}

.hhh {
  font-size: 20px;
  color: #1a2332;
  position: absolute;
  left: 50%;
  top: 180px;
  transform: translate(-50%, 0);
}
.cred_chart {
  width: 520px;
}
.echarts {
  position: relative;
  height: 220px;
  padding: 0 20px;
}

.table_box {
  position: relative;
  padding-top: 10px;
  margin-top: 70px;
  margin-bottom: 50px;
}

.echarts-content {
  margin-top: 40px;
  padding: 0 20px 0 50px;
}

.echarts-item {
  display: flex;
  justify-content: flex-start;
  font-size: 20px;
  color: #666;
  margin-bottom: 30px;
}

.echarts-item-left {
  display: inline-block;
  width: 228px;
  margin-right: 40px;
  color: #1a2332;
  font-family: "Arial Bold";
}

.ecahrtstutwo {
  position: relative;
  left: 20px;
}

.left_box {
  width: 91%;
}
.right_box {
  width: 40%;
  background-color: #fff;
}
.CompanyDetails {
  color: #ffffff;
  width: 180px;
  height: 40px;
  background: #009ea7;
  border-radius: 10px;
  display: block;
  line-height: 40px;
  text-align: center;
  cursor: pointer;
}
.comp_compet {
  overflow: hidden;
  padding-bottom: 0 !important;
}
.attr_table {
  width: 800px;
}
.cred_table_chart {
  width: calc(100% - 530px);
}
::v-deep .CompetitivenessTable {
  padding-left: 10px;
}
::v-deep .compet_table_cell_right {
  padding-left: 20px;
}
::v-deep .compet_table_cell_right .cell {
  padding-right: 0 !important;
}
::v-deep .table_contentHeight_55.el-table td.el-table__cell {
  height: 80px !important;
}
.font26 {
  font-size: 26px !important;
}
@media (max-width: 1920px) {
  .aaa,
  .bbb,
  .ccc,
  .ddd,
  .fff,
  .ggg {
    font-size: 12px;
  }

  .fff {
    width: auto !important;
  }
  .hhh {
    font-size: 14px;
    top: 180px;
  }
  .echarts {
    position: relative;
    padding: 0 15px;
  }
  .cred_chart {
    width: 435px;
  }
  .aaa {
    left: 20px;
    top: 190px;
  }

  .bbb {
    left: 25px;
    top: 80px;
  }

  .ccc {
    left: 110px;
    top: 0px;
  }
  .ddd {
    left: 295px;
    top: 5px;
  }
  .fff {
    left: 375px;
    top: 90px;
  }
  .ggg {
    left: 365px;
    top: 190px;
  }
  .table_box {
    position: relative;
    margin-top: 52px;
    margin-bottom: 20px;
  }
  .echarts-content {
    margin-top: 30px;
    padding: 0 15px 0 37px;
  }
  .echarts-item {
    font-size: 18px;
    margin-bottom: 22px;
  }
  .echarts-item-left {
    width: 200px;
    margin-right: 30px;
  }
  .ecahrtstutwo {
    left: 15px;
  }
  .cred_table_chart {
    width: calc(100% - 442px);
  }
  ::v-deep .table_contentHeight_55.el-table td.el-table__cell {
    height: 60px !important;
  }
  .font26 {
    font-size: 20px !important;
  }
}

@media screen and (max-width: 1439px) {
  .echarts {
    position: relative;
    padding: 0 13px;
  }
  .cred_chart {
    width: 435px;
  }
  .table_box {
    position: relative;
    margin-top: 46px;
    margin-bottom: 20px;
  }
  .echarts-content {
    margin-top: 30px;
    padding: 0 13px 0 33px;
  }
  .echarts-item {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .echarts-item-left {
    width: 190px;
    margin-right: 26px;
  }
  .ecahrtstutwo {
    left: 13px;
  }
  .cred_table_chart {
    width: calc(100% - 440px);
  }
  ::v-deep .table_contentHeight_55.el-table td.el-table__cell {
    height: 54px !important;
  }
  .font26 {
    font-size: 18px !important;
  }
}
</style>
